"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SkillsetMetadataStorageV1Factory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var SkillsetMetadataStorageV1Factory = /** @class */ (function (_super) {
    __extends(SkillsetMetadataStorageV1Factory, _super);
    function SkillsetMetadataStorageV1Factory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    SkillsetMetadataStorageV1Factory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    SkillsetMetadataStorageV1Factory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    SkillsetMetadataStorageV1Factory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    SkillsetMetadataStorageV1Factory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    SkillsetMetadataStorageV1Factory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return SkillsetMetadataStorageV1Factory;
}(contracts_1.ContractFactory));
exports.SkillsetMetadataStorageV1Factory = SkillsetMetadataStorageV1Factory;
var _abi = [
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "approvedSkillsets",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "maxLevel",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "skillsetsArray",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
];
var _bytecode = "0x608060405234801561001057600080fd5b50610174806100206000396000f3fe608060405234801561001057600080fd5b50600436106100415760003560e01c80636dfd5df314610046578063a8b3dd5714610080578063c2252b55146100b9575b600080fd5b61006c6004803603602081101561005c57600080fd5b50356001600160a01b03166100f1565b604080519115158252519081900360200190f35b61009d6004803603602081101561009657600080fd5b5035610106565b604080516001600160a01b039092168252519081900360200190f35b6100df600480360360208110156100cf57600080fd5b50356001600160a01b031661012d565b60408051918252519081900360200190f35b60006020819052908152604090205460ff1681565b6001818154811061011357fe5b6000918252602090912001546001600160a01b0316905081565b6002602052600090815260409020548156fea265627a7a72315820ef36ae0996815c13ae764d08be773592cdccfe20db05aa8bc3f1b159eebbcc8464736f6c63430005100032";
//# sourceMappingURL=SkillsetMetadataStorageV1Factory.js.map